/* Complements Broadcast's native hover/focus disclosure and editor lifecycle. */
(() => {
  if (window.mbEditorialMenuLoaded) return;
  window.mbEditorialMenuLoaded = true;
  const selector = '[data-mb-desktop-item]';
  const instances = new WeakMap();

  function setup(item) {
    if (instances.has(item) || item.closest('.js__header__clone')) return;
    const panel = item.querySelector('[data-mb-desktop-panel]');
    const toggle = item.querySelector('[data-mb-desktop-toggle]');
    const header = item.closest('[data-header-wrapper]');
    const controller = new AbortController();
    const options = {signal: controller.signal};
    function hydrate() {
      panel.querySelectorAll('noscript[data-mb-editorial-image]').forEach(fallback => {
        const template = document.createElement('template');
        template.innerHTML = fallback.textContent;
        fallback.replaceWith(template.content);
      });
    }
    function sync() {
      const open = panel.classList.contains('is-visible');
      toggle.setAttribute('aria-expanded', String(open));
      if (open) hydrate();
    }
    function close(returnFocus = false) {
      panel.classList.remove('is-visible');
      item.classList.remove('is-visible');
      item.setAttribute('aria-expanded', 'false');
      if (!header?.querySelector('[data-mb-desktop-panel].is-visible')) header?.classList.remove('meganav--visible','meganav--is-transitioning');
      if (returnFocus) toggle.focus();
      sync();
    }
    function open() {
      header?.querySelectorAll(selector).forEach(other => {
        if (other !== item) instances.get(other)?.close();
      });
      panel.classList.add('is-visible');
      item.classList.add('is-visible');
      item.setAttribute('aria-expanded','true');
      header?.classList.add('meganav--visible');
      sync();
    }
    toggle.addEventListener('touchstart', event => event.stopPropagation(), {...options,passive:true});
    toggle.addEventListener('click', () => panel.classList.contains('is-visible') ? close() : open(), options);
    item.querySelector('[data-mb-desktop-close]').addEventListener('click', () => close(true), options);
    item.addEventListener('keydown', event => {
      if (event.key === 'Escape') {event.preventDefault();event.stopPropagation();close(true);}
      if (event.key === 'ArrowDown' && (event.target === toggle || event.target.matches('[data-top-link]'))) {
        event.preventDefault();open();panel.querySelector('a')?.focus();
      }
    }, options);
    // Mouse hover stays native. Touch users have a real disclosure button.
    document.addEventListener('pointerdown', event => {
      if (!item.contains(event.target)) close();
    }, options);
    const observer = new MutationObserver(sync);
    observer.observe(panel,{attributes:true,attributeFilter:['class']});
    instances.set(item,{open,close,destroy:()=>{controller.abort();observer.disconnect();instances.delete(item);}});
    sync();
  }
  function init(root) {root.querySelectorAll(selector).forEach(setup);}
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll(selector).forEach(item => instances.get(item)?.destroy()));
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest(selector);
    if (item) instances.get(item)?.open();
  });
  document.addEventListener('shopify:block:deselect', event => {
    const item = event.target.closest(selector);
    if (item) instances.get(item)?.close();
  });
})();
